import { CustomFormModel } from "types/generated/models";
import { ICompositionParams } from "../Form.types";
import {
    IComposition,
    ICustomProfileFieldOption,
    IDrawing,
    ILookupItem,
} from "common.ui/CustomForms/Editor/DataTypes/IStore";
import { CountryCode, Mode } from "common.ui/CustomForms/Editor/DataTypes/dataTypes";

interface DrawingData {
    name?: string;
    url?: string;
}

export function convertToCompositionParams(
    data: CustomFormModel,
    publicId: string,
    clientPortalGuid: string
): ICompositionParams {
    const convertedComposition: IComposition = {
        sections: (data.customForm.composition?.sections as unknown as IComposition["sections"]) || [],
    };

    const convertDrawings = (drawings: DrawingData[] | null | undefined): IDrawing[] => {
        if (!drawings) return [];
        return drawings.map((drawing) => ({
            name: drawing.name || "",
            url: drawing.url || "",
        }));
    };

    return {
        templateId: data.customForm.id || 0,
        customFormId: data.customForm.id || 0,
        composition: convertedComposition,
        drawingsAvailable: convertDrawings(data.customForm.drawings as DrawingData[]),
        formType: data.customForm.formType || 0,
        status: data.customForm.status || 0,
        defaultMode: Mode.DataEntry,
        uploadClientFilesUrl: `/api/v1/${clientPortalGuid}/File/UploadClientFile?publicId=${publicId}`,
        lookups: data.customForm.lookups as unknown as Map<string, ILookupItem[]>,
        sgCountryCode: (data.customForm.sgCountryCode as CountryCode) || CountryCode.None,
        customLookups: data.customForm.customLookups as unknown as Map<string, ILookupItem[]>,
        customProfileFields: data.customForm.customProfileFields as ICustomProfileFieldOption[],
        clientFileMaxNumber: data.compositionParameters.clientFileMaxNumber,
        clientFileMaxSize: data.compositionParameters.clientFileMaxSize,
        clientFileAllowedExtensions: data.compositionParameters.clientFileAllowedExtensions ?? [],
        bsDateFormat: data.compositionParameters.bsDateFormat,
        bsWeekStart: data.customForm.weekStart,
        shortDateFormat: data.compositionParameters.shortDateFormat,
    };
}
